import MyStoreModule from './MyStoreModule.component';

export default MyStoreModule;